<template>
  <section class="py-8">
    <!-- ローディング表示を追加 -->
    <div class="loading-overlay" v-if="isLoading">
      <div class="spinner-border text-danger" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="container">
      <!-- {{ get_auth }} -->
      <h2 class="title page__h1 pt-32 pb-32">決済</h2>
      <div class="row">
        <div class="box box--center mb-24" v-if="isPaymentComplete">
          <p>決済が完了いたしました。<br />マイページページお戻り下さい。</p>
        </div>
        <div v-else>
          <div
            class="box box--center mb-24"
            :style="
              selected_charge_type === 'cash' && has_receipt_data
                ? 'margin-bottom:0;padding-bottom:0;'
                : ''
            "
          >
            <p v-if="!has_receipt_data && selected_charge_type === 'creditcard'">
              決済を行って下さい。
            </p>
            <p v-else-if="!has_receipt_data && selected_charge_type === 'cash'">
              コンビニ払いを選択するをクリックしてください
            </p>
            <p v-else class="mb-24">
              お支払い情報を確認し、コンビニでのお支払いをお願いいたします。
            </p>
          </div>
          <div class="col-12 pb-32">
            <div>
              <div class="card-body">
                <div v-if="!has_receipt_data">
                  <CartView
                    :selected_variants="selected_variants"
                    :race_sports_year="race_sports_year"
                    :draft_orders="draft_orders"
                    :sales_data="sales_data"
                  />
                </div>
                <div class="container px-0">
                  <!-- 支払い方法 -->
                  <div class="mb-3">
                    <div
                      v-if="!has_receipt_data && false"
                      class="container mb-4 pb-4 border-bottom"
                    >
                      <div class="row">
                        <div
                          class="col"
                          v-for="type in charge_type_list"
                          :key="type"
                        >
                          <div class="d-grid">
                            <button
                              type="button"
                              :class="getClassChargeType(type.key)"
                              @click="sel_charge_type(type.key)"
                            >
                              {{ type.label }}で支払う
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="container">
                      <div
                        class="row"
                        v-show="selected_charge_type == 'creditcard'"
                      >
                        <h3 class="title02 page__h2">クレジットカード</h3>
                        <div class="col-10 offset-1 col-lg-8 offset-lg-2 mb-10">
                          <div class="row">
                            <div
                              class="col-12 col-sm-6 col-md-8 mb-10 text-center"
                            >
                              ご利用可能カードブランド
                            </div>
                            <div
                              class="col-12 col-sm-6 col-md-4 mb-10 text-center"
                            >
                              <img
                                :src="
                                  assets_url +
                                  '/base/creditcard_checkout_logo.png'
                                "
                                class="w-75"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-10 offset-1 col-lg-8 offset-lg-2 mb-3" v-if="sw_card_payer">
                          <h5 class="h5">支払い情報</h5>
                          <p class="alert alert-info">
                            主催者の代表者カナ名と電話番号を記入して下さい。
                          </p>
                        </div>
                        <div class="col-10 offset-1 col-lg-8 offset-lg-2 mb-32" v-if="sw_card_payer">
                          <!-- <label for="card_payer_phoneNumber" v-if="false">氏名:</label>
                          <input
                            v-if="false"
                            type="text"
                            id="card_payer_name"
                            v-model="card_payer_obj.name"
                            class="form-control mb-2"
                            placeholder="氏名"
                            :aria-invalid="!!card_payer_error.name"
                          />
                          <p v-if="card_payer_error.name" class="text-danger">{{ card_payer_error.name }}</p> -->
                          <label for="card_payer_phoneNumber">主催者の代表者カナ名:</label>
                          <input
                            type="text"
                            id="card_payer_nameKana"
                            v-model="card_payer_obj.nameKana"
                            class="form-control mb-2"
                            placeholder="カナ"
                            :aria-invalid="!!card_payer_error.nameKana"
                          />
                          <p v-if="card_payer_error.nameKana" class="text-danger">{{ card_payer_error.nameKana }}</p>
                          <label for="card_payer_phoneNumber">電話番号:</label>
                          <input
                            type="text"
                            id="card_payer_phoneNumber"
                            v-model="card_payer_obj.phoneNumber"
                            class="form-control mb-2"
                            placeholder="電話番号"
                            :aria-invalid="!!card_payer_error.phoneNumber"
                          />
                          <p v-if="card_payer_error.phoneNumber" class="text-danger">{{ card_payer_error.phoneNumber }}</p>
                        </div>
                        <div class="col-10 offset-1 col-lg-8 offset-lg-2 mb-3" v-if="sw_card_payer">
                          <h5 class="h5">カード情報</h5>
                          <p class="alert alert-info">
                            お支払いになるカード情報を記入してください。
                          </p>
                        </div>
                        <div class="col-10 offset-1 col-lg-8 offset-lg-2">
                          <label for="card-number">カード番号:</label>
                          <div id="card-number" class="card-form__div" />
                          <label for="expiry-month">有効期限:</label>
                          <div id="expiry-month" class="card-form__div" />
                          <label for="security-code">セキュリティコード:</label>
                          <div id="security-code" class="card-form__div" />
                          <label for="holder-name">カード名義人:</label>
                          <input
                            type="text"
                            id="holder-name"
                            v-model="holder_name"
                            class="form-control mb-2"
                            placeholder="TARO YAMADA"
                          />
                        </div>
                      </div>
                      <div class="row" v-show="selected_charge_type == 'cash'">
                        <div
                          v-if="!has_receipt_data"
                          class="col-10 offset-1 col-lg-8 offset-lg-2"
                        >
                          <h3 class="title02 page__h2">コンビニ支払い</h3>
                          <KonbiniForm
                            :on-submit="chargeCash"
                            :ini_payer="get_payer"
                          />
                        </div>
                        <div class="col-10 offset-1 col-lg-8 offset-lg-2">
                          <h5>コンビニお支払い情報</h5>
                          <div>
                            <ul v-if="has_receipt_data" class="list-group">
                              <li
                                v-for="(value, key) in receipt"
                                :key="key"
                                class="list-group-item d-flex justify-content-between"
                              >
                                <span
                                  class="fw-bold text-capitalize"
                                  v-if="key == 'konbiniCode'"
                                  >コンビニ</span
                                >
                                <span
                                  class="fw-bold text-capitalize"
                                  v-else-if="key == 'receiptNumber'"
                                  >お客様番号</span
                                >
                                <span
                                  class="fw-bold text-capitalize"
                                  v-else-if="key == 'confirmationNumber'"
                                  >確認番号</span
                                >
                                <span class="text-muted">{{ value }}</span>
                              </li>
                            </ul>
                            <h2>各社のご案内</h2>
                            <ul>
                              <li v-for="(link, index) in links" :key="index">
                                <a :href="link.href" target="_blank">{{
                                  link.text
                                }}</a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="" v-if="selected_charge_type == 'creditcard'">
                  <div class="box">
                    <h5 class="title06 page__h6">
                      クレジットカード決済について
                    </h5>
                    <p class="text-start">
                      こちらのページでクレジットカード情報を入力して決済を完了させてください。<br />
                      当サイトでの決済はセキュリティ対策として、カード情報を直接保存せずトークン化して処理しています。<br />
                      クレジットカードがご利用いただけない場合は、コンビニ決済をご利用ください。<br />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-wrap mt-32 justify-content-center column-gap-24">
        <button
          class="button03 mb-3 license__btn"
          type="button"
          @click="goBack"
        >
          <font-awesome-icon
            :icon="['fas', 'chevron-left']"
            class="button03__icon"
          />
          <span class="button03__text">戻る</span>
        </button>
        <button
          class="button04 mb-3 license__btn"
          type="button"
          @click="goCharge"
          v-if="selected_charge_type === 'creditcard' && !isPaymentComplete"
          :disabled="isLoading || charge_btn_disabled"
        >
          <span class="button04__text">
            <template v-if="isLoading">処理中...</template>
            <template v-else>支払う</template>
          </span>
          <font-awesome-icon
            :icon="['fas', 'chevron-right']"
            class="button04__icon"
          />
        </button>
      </div>
    </div>
  </section>
</template>

<script>
  // ルーターとストア関連
  import { useRouter } from 'vue-router'
  import { useStore } from 'vuex'

  // コンポーネント
  import KonbiniForm from '@/components/forms/KonbiniForm.vue'
  import CartView from '../Request/OCartView.vue'

  // 設定と外部ライブラリ
  import config from '../../../const'
  // import Common from '../../../common/common'
  import axios from 'axios'

  // 決済関連
  import { usePaymentPage } from '@ootbteam/mulpay-pinia'
  import {
    cardInputStyle,
    cvcInputStyle,
    expiryInputStyle,
  } from '@/utils/cardstyle'

  /**
   * 決済ページコンポーネント
   * クレジットカードとコンビニ決済の処理を管理する
   */
  export default {
    name: 'SalesOwnerPaymentView',
    components: {
      KonbiniForm,
      CartView,
    },

    setup() {
      const router = useRouter()
      const store = useStore()

      // MulPay SDK関連の関数を取得
      const {
        handlePaymentPageProps,
        setPaymentPayload,
        setCardPaymentPayload,
        cardPayment,
        cashPaymentForOwner,
        setElements,
        setHolderName,
        clear,
      } = usePaymentPage()

      return {
        router,
        store,
        handlePaymentPageProps,
        setPaymentPayload,
        setCardPaymentPayload,
        cardPayment,
        cashPaymentForOwner,
        setElements,
        setHolderName,
        clear,
      }
    },

    data: function () {
      return {
        // 販売データ関連
        data_obj: {},
        selected_variants: [],
        race_sports_year: [],
        draft_orders: [],
        sales_data: {},

        // 決済設定
        selected_charge_type: 'creditcard',
        charge_type_list: [
          { key: 'creditcard', label: 'クレジットカード' },
          { key: 'cash', label: 'コンビニ' },
          { key: 'invoice', label: '請求書'},
          // { key: 'zero', label: ''}
        ],
        merchant_obj: {},

        // カード要素
        cardNumberElement: null,
        expiryElement: null,
        cvcElement: null,
        holder_name: '',
        cardValidation: {
          cardNumber: { complete: false, error: null },
          expiry: { complete: false, error: null },
          cvc: { complete: false, error: null },
        },
        // カード氏名、電話オブジェクト
        sw_card_payer: true,
        card_payer_obj: {
          // name: '',
          nameKana: '',
          phoneNumber: ''
        },
        card_payer_error: {
          // name: '',
          nameKana: '',
          phoneNumber: ''
        },
        card_payer_billingAddress: {

        },
        // コンビニ関連
        has_receipt_data: false,
        receipt: {},
        links: [
          {
            code: 'SEVEN_ELEVEN',
            text: 'セブンイレブン',
            href: 'https://static.mul-pay.jp/customer-convenience-store/seveneleven/index.html',
          },
          {
            code: 'LAWSON',
            text: 'ローソンの「Loppi」を使ってお支払い（お客様番号が11桁の場合）',
            href: 'https://static.mul-pay.jp/customer-convenience-store/lawson/11.html',
          },
          {
            code: 'LAWSON',
            text: 'ローソンの「Loppi」を使ってお支払い（お客様番号が14桁の場合）',
            href: 'https://static.mul-pay.jp/customer-convenience-store/lawson/14.html',
          },
          {
            code: 'FAMILYMART',
            text: 'ファミリーマートの「マルチコピー機」を使ってお支払い（第1番号11桁の場合）',
            href: 'https://www.family.co.jp/services/application/receipt.html',
          },
          {
            code: 'FAMILYMART',
            text: 'ファミリーマートの「マルチコピー機」を使ってお支払い（第2番号12桁の場合）',
            href: 'https://www.family.co.jp/services/application/receipt.html',
          },
          {
            code: 'MINISTOP',
            text: 'ミニストップの「Loppi」を使ってお支払い（お客様番号が11桁の場合）',
            href: 'https://static.mul-pay.jp/customer-convenience-store/ministop/11.html',
          },
          {
            code: 'MINISTOP',
            text: 'ミニストップの「Loppi」を使ってお支払い（お客様番号が14桁の場合）',
            href: 'https://static.mul-pay.jp/customer-convenience-store/ministop/14.html',
          },
          {
            code: 'SEICOMART',
            text: 'セイコーマートの「POSレジ」を使ってお支払い',
            href: 'https://static.mul-pay.jp/customer-convenience-store/seicomart/',
          },
        ],

        // UI状態
        isLoading: false,
        charge_btn_disabled: false,
        assets_url: config.BASE_ASSETS_URL,
        isPaymentComplete: false,

        // 追加が必要なプロパティ
        member_license: [], // または適切な初期値
        license_obj: {}, // 必要に応じて
        // その他attach_have_licenseで使用される配列やオブジェクト
      }
    },

    methods: {
      async loadSalesData() {
        this.isLoading = true
        try {
          const salesId = this.router.currentRoute.value.query.tkn
          if (!salesId) {
            alert(
              '決済IDが指定されていません。前のページからやり直してください。'
            )
            location.href = config.BASE_APP_URL + '/owner/mypage'
          // } else if (this.application_obj.application_check_type === '420') {
          //   location.href = config.BASE_APP_URL
          }

          const params = { id: salesId, stat: [1] }
          const response = await this.basicPosts_S(
            config.BASE_API_URL + '/sales/lists',
            params
          )

          if (
            response?.data?.status === 200 &&
            response.data.body?.length > 0
          ) {
            // 指定されたIDに一致するデータを検索
            const exactMatch = response.data.body.find(
              (item) => item.id === salesId
            )
            this.sales_data = exactMatch || response.data.body[0]
            console.log('sales_data = ', this.sales_data, '')
            this.selected_variants = this.sales_data.selected_variants || []
            this.race_sports_year = this.sales_data.race_sports_year || []
            this.draft_orders = this.sales_data.draft_orders || []
            if(this.sales_data?.charge_type == 'INVOICE'){
              this.selected_charge_type = 'invoice'
            }
            else if(this.sales_data?.charge_type == 'ZERO' || this.sales_data?.charge_type == 'ZINVOICE'){
              this.selected_charge_type = 'zero'
            }
            else if(this.sales_data?.charge_type == 'KONBINI'){
              this.selected_charge_type = 'cash'

              if(
                this.sales_data?.cash_konbini_code && 
                this.sales_data?.cash_confirmation_number && 
                this.sales_data?.cash_receipt_number 
              ){
                const tmps = {
                  konbiniCode: this.sales_data?.cash_konbini_code,
                  receiptNumber: this.sales_data?.cash_confirmation_number,
                  confirmationNumber: this.sales_data?.cash_receipt_number
                }
                this.receipt = tmps
              }
            }
            console.log('loadSalesData sales_data', this.sales_data)

          } else {
            alert(
              '販売データが見つかりませんでした。ページを再読み込みするか、前のページからやり直してください。'
            )
          }
        } catch (error) {
          console.error('販売データ取得エラー:', error)
          alert('販売データの取得中にエラーが発生しました。')
        } finally {
          this.isLoading = false
        }
      },

      getClassChargeType(type) {
        return {
          btn: true,
          'btn-outline-secondary': this.selected_charge_type !== type,
          'btn-warning': this.selected_charge_type === type,
        }
      },

      _trimAll(s) {
        if (typeof s !== "string") return "";
        // 先頭末尾トリム & 中のスペースのみ許可したい場合はここを調整
        return s.replace(/^\s+|\s+$/g, "").replace(/\u3000/g, "");
      },
      async sel_charge_type(charge_type) {
        this.isLoading = true
        try {
          // this.selected_charge_type = charge_type
          await this.update_sales_order_id(charge_type)
          await this.loadSalesData()
          await this.loadApplicationObj()
        } catch (error) {
          console.error('支払い方法選択エラー:', error)
          alert('支払い方法の選択中にエラーが発生しました。')
        } finally {
          this.isLoading = false
        }
      },

      goBack() {
        // location.href = config.BASE_APP_URL + '/owner/mypage'
        const from = this.router.options.history.state.back

        if (from && from.includes('/owner/mypage')) {
          // 特定のURLから来た場合は戻る
          this.router.go(-1)
        } else {
          // それ以外は別処理（例: トップへ遷移）
          location.href =  config.SSO_SITE_URL + '/event/'
        }
      },
      card_payer_validate(){
        // this.card_payer_error = { name: "", nameKana: "", phoneNumber: "" };
        this.card_payer_error = { nameKana: "", phoneNumber: "" };

        // 氏名チェック（必須）
        // const name = this._trimAll(this.card_payer_obj.name);
        // if (!name) {
        //   this.card_payer_error.name = "氏名を入力してください。";
        // }
        // 必須：カナ（全角カタカナのみ）
        const nameKana = this._trimAll(this.card_payer_obj.nameKana);
        // ESLint対策（全角スペースは \u3000 で書く）
        const kanaRegex = /^[ァ-ヶー\u3000]+$/;
        if (!nameKana) {
          this.card_payer_error.nameKana = "カナを入力してください。";
        } else if (!kanaRegex.test(nameKana)) {
          this.card_payer_error.nameKana = "カナは全角カタカナで入力してください。";
        }
        // 電話番号：数字とハイフンのみ（必須にするなら空チェックを追加）
        const phone = this._trimAll(this.card_payer_obj.phoneNumber);
        const phoneRegex = /^[0-9-]+$/; // 「\-」は不要なので no-useless-escape も回避
        if (!phone) {
          this.card_payer_error.phoneNumber = "電話番号を入力してください。";
        } else if (!phoneRegex.test(phone)) {
          this.card_payer_error.phoneNumber = "電話番号は数字とハイフンのみで入力してください。";
        }

        // return !this.card_payer_error.name && !this.card_payer_error.nameKana && !this.card_payer_error.phoneNumber;
        return !this.card_payer_error.nameKana && !this.card_payer_error.phoneNumber;
      },
      async goCharge() {
        this.isLoading = true
        try {
          if (this.selected_charge_type === 'creditcard') {
            if(!this.sw_card_payer){
              await this.charge_credit()
            }
            else if(this.card_payer_validate()){
              await this.charge_credit()
            }else{
              alert('支払者情報を確認してください。')
            }
          }
        } catch (error) {
          console.error('決済エラー:', error)
          alert('お支払い処理中にエラーが発生しました。')
        } finally {
          this.isLoading = false
        }
      },
      async mp_token_mount() {
        // MpTokenに必要な情報を設定
        const mulpay = await this.handlePaymentPageProps({
          instance: axios.create({
            baseURL: config.BASE_API_URL,
            headers: {
              'Content-Type': 'application/json',
            },
          }),
          apiKey: config.GMO_MP_TOKEN_API_KEY_MFJ,
          pubKey: config.GMO_MP_TOKEN_PUB_KEY_MFJ,
          productionMode: config.GMO_SHOP_OP_MODE,
        })
        console.log('mounted !!', mulpay)

        const elements = mulpay.createElements()

        const cardNumberInputElement = elements.create('cardNumber', {
          style: cardInputStyle,
          placeholder: 'Card Number',
        })
        const expiryInputElement = elements.create('cardExpiry', {
          style: expiryInputStyle,
        })
        const cvcInputElement = elements.create('cardCvc', {
          style: cvcInputStyle,
        })

        const cardNumberWrapperElement = document.getElementById('card-number')
        const cardExpiryWrapperElement = document.getElementById('expiry-month')
        const cardCvcWrapperElement = document.getElementById('security-code')

        cardNumberInputElement.mount(cardNumberWrapperElement)
        expiryInputElement.mount(cardExpiryWrapperElement)
        cvcInputElement.mount(cardCvcWrapperElement)

        this.setElements(
          cardNumberInputElement,
          expiryInputElement,
          cvcInputElement
        )
      },
      async setApplicationObj() {
        console.log('!!!setApplicationObj')
        const tmps =
          typeof this.application_obj === 'object' &&
          Object.keys(this.application_obj).length > 0
            ? this.application_obj
            : {
                id: 0,
                application_check_type: '',
                application_type: '',
                application_date: '',
              }
        this.application_obj = tmps

        this.communication_obj =
          this.application_obj &&
          this.application_obj.communications &&
          this.application_obj.communications[0]
            ? this.application_obj.communications[0]
            : {}
        this.communication_checked =
          this.application_obj && this.application_obj.checked
            ? this.application_obj.checked
            : []

        // pagemode
        console.log('setApplicationObj tmps', tmps)
        // 決済(application_check_type:400-423)
        if (
          (this.application_obj || {}).application_check_type == 400 &&
          parseInt((this.application_obj || {}).o_id) > 0
        ) {
          this.page_mode = 'charge'
          await this.mp_token_mount()
        } else if (
          (this.application_obj || {}).application_check_type == 200 &&
          parseInt((this.application_obj || {}).o_id) > 0
        ) {
          this.page_mode = 'check'
          await this.mp_token_mount()
        }
        // 決済エラー
        else if (
          (this.application_obj || {}).application_check_type == 403 &&
          parseInt((this.application_obj || {}).o_id) > 0
        ) {
          // ここでもう一度appをチェックして、決済もチェックして問題ないか確認させる
          const sales =
            typeof (this.application_obj || {}).sales === 'object' &&
            Object.keys(this.application_obj.sales).length > 0
              ? { ...(this.application_obj || {}).sales }
              : false
          const sales_id = sales ? sales.id : 0
          const sparams = {}
          sparams['stat'] = [1]
          sparams['id'] = sales_id
          const success_check = await this.basicPosts_S(
            config.BASE_API_URL + '/sales/success_check',
            sparams
          )
            .then(async (response) => {
              console.log('success_check response', response)
              return response?.data?.body ? response.data.body : false
            })
            .catch(async (err) => {
              console.log(err)
              return false
            })
          console.log('403 check success_check', success_check)
          if (!success_check) {
            await this.update_app_check(400)
            this.page_mode = 'charge'
            this.message_class = 'danger'
          } else if (success_check) {
            const chkTYpe =
              sales.charge_type == 'CREDIT'
                ? 423
                : sales.charge_type == 'KONBINI'
                ? 426
                : 423
            await this.update_app_check(chkTYpe)
            return
          }
        }
        // 決済成功
        else if (
          ((this.application_obj || {}).application_check_type == 426 ||
            (this.application_obj || {}).application_check_type == 423) &&
          parseInt((this.application_obj || {}).o_id) > 0
        ) {
          const tmps = [...(this.application_obj || {}).draft_orders]
          this.draft_order_obj = [...tmps]

          this.page_mode = 'charge'
          // await this.member_license_update()
          await this.update_app_check(430)
          // return;
        }
        // 決済成功して戻ってくる
        else if (
          (this.application_obj || {}).application_check_type == 430 &&
          parseInt((this.application_obj || {}).o_id) > 0
        ) {
          this.page_mode = 'success'
          await this.update_app_check(500)
        }
        // コンビニ申し込み、支払い町
        else if (
          (this.application_obj || {}).application_check_type == 420 &&
          parseInt((this.application_obj || {}).o_id) > 0
        ) {
          this.page_mode = 'cash_unpaid'
          this.has_receipt_data = true
        }
        // コンビニ申し込み、支払い町
        else if (
          (this.application_obj || {}).application_check_type == 100 &&
          parseInt((this.application_obj || {}).o_id) > 0
        ) {
          this.page_mode = 'check'
        }
        // 差し戻しがある
        else if (
          (this.application_obj || {}).application_check_type == 600 &&
          parseInt((this.application_obj || {}).o_id) > 0
        ) {
          this.page_mode = 'remand'
        }

        // selected_variant取得
        // if (
        //   (this.charge_mode || this.remand_mode) &&
        //   typeof (this.application_obj || {}).draft_orders === 'object'
        // ) {
        //   // 一旦クリアする
        //   this.selected_variants = []
        //   this.draft_order_obj = [...this.application_obj.draft_orders]
        //   console.log('!!!draft_order_obj', this.draft_order_obj)
        //   await Promise.all(
        //     this.application_obj.draft_orders.map(async (order, idx) => {
        //       console.log(
        //         '!!!selected idx',
        //         idx,
        //         order.variant_id,
        //         order.sports_year_add
        //       )
        //       await this.sel_variant_year(
        //         order.variant_id,
        //         order.sports_year_add,
        //         true
        //       )
        //     })
        //   )
        //   console.log('!!!selected', this.selected_variants)
        // }

        // this.app_form_obj = {
        //   name_1: (this.get_target_app_item('mfj_member_data@name_1') || {})
        //     .application_value
        //     ? (this.get_target_app_item('mfj_member_data@name_1') || {})
        //         .application_value
        //     : '',
        //   name_1_message: (
        //     this.get_target_app_item('mfj_member_data@name_1') || {}
        //   ).message
        //     ? (this.get_target_app_item('mfj_member_data@name_1') || {}).message
        //     : '',
        //   yomi_1: (this.get_target_app_item('mfj_member_data@yomi_1') || {})
        //     .application_value
        //     ? (this.get_target_app_item('mfj_member_data@yomi_1') || {})
        //         .application_value
        //     : '',
        //   yomi_1_message: (
        //     this.get_target_app_item('mfj_member_data@yomi_1') || {}
        //   ).message
        //     ? (this.get_target_app_item('mfj_member_data@yomi_1') || {}).message
        //     : '',
        //   path1: (this.get_target_app_item('mfj_member_assets@path1') || {})
        //     .application_value
        //     ? (this.get_target_app_item('mfj_member_assets@path1') || {})
        //         .application_value
        //     : '',
        //   path2: (this.get_target_app_item('mfj_member_assets@path2') || {})
        //     .application_value
        //     ? (this.get_target_app_item('mfj_member_assets@path2') || {})
        //         .application_value
        //     : '',
        //   path3: (this.get_target_app_item('mfj_member_assets@path3') || {})
        //     .application_value
        //     ? (this.get_target_app_item('mfj_member_assets@path3') || {})
        //         .application_value
        //     : '',
        //   path4: (this.get_target_app_item('mfj_member_assets@path4') || {})
        //     .application_value
        //     ? (this.get_target_app_item('mfj_member_assets@path4') || {})
        //         .application_value
        //     : '',
        //   path5: (this.get_target_app_item('mfj_member_assets@path5') || {})
        //     .application_value
        //     ? (this.get_target_app_item('mfj_member_assets@path5') || {})
        //         .application_value
        //     : '',
        //   path6: (this.get_target_app_item('mfj_member_assets@path6') || {})
        //     .application_value
        //     ? (this.get_target_app_item('mfj_member_assets@path6') || {})
        //         .application_value
        //     : '',
        //   path10: (this.get_target_app_item('mfj_member_assets@path10') || {})
        //     .application_value
        //     ? (this.get_target_app_item('mfj_member_assets@path10') || {})
        //         .application_value
        //     : '',
        //   path11: (this.get_target_app_item('mfj_member_assets@path11') || {})
        //     .application_value
        //     ? (this.get_target_app_item('mfj_member_assets@path11') || {})
        //         .application_value
        //     : '',
        //   path_message: (
        //     this.get_target_app_item('mfj_member_assets@path') || {}
        //   ).message
        //     ? (this.get_target_app_item('mfj_member_assets@path') || {}).message
        //     : '',
        //   path_type: (
        //     this.get_target_app_item('mfj_outdb_data@path_type') || {}
        //   ).application_value
        //     ? (this.get_target_app_item('mfj_outdb_data@path_type') || {})
        //         .application_value
        //     : '',
        // }
        // this.page_mode = 'success'
        // this.$forceUpdate();
      },

      updateChargeButtonState() {
        if (this.selected_charge_type !== 'creditcard') return

        const isFormComplete =
          this.cardValidation.cardNumber.complete &&
          this.cardValidation.expiry.complete &&
          this.cardValidation.cvc.complete

        const hasErrors =
          (this.cardValidation.cardNumber.error &&
            this.cardValidation.cardNumber.error.type !== 'validation_error') ||
          (this.cardValidation.expiry.error &&
            this.cardValidation.expiry.error.type !== 'validation_error') ||
          (this.cardValidation.cvc.error &&
            this.cardValidation.cvc.error.type !== 'validation_error')

        this.charge_btn_disabled = !(isFormComplete && !hasErrors)
      },

      async charge_credit() {
        try {
          /**
           * カード名義人を指定する場合（設定する場合は、注意が必要）
           * @see: https://static.mul-pay.jp/doc/card-token/#tag/elements/mulpay.getTokenThroughIframe(elementholdernameoptions)
           */
          this.setHolderName(this.holder_name)
        } catch (e) {
          alert(e.message)
          return
        }

        this.charge_btn_disabled = true
        this.isLoading = true

        try {
          console.log('get_payer', this.get_payer)
          console.log('set_payer_obj', this.set_payer_obj)
          console.log('get_merchant', this.get_merchant)
          console.log('get_order', this.get_order)
          await this.setCardPaymentPayload({
            payer: (this.sw_card_payer)? this.set_payer_obj: this.get_payer,
            merchant: this.get_merchant,
            order: this.get_order,
          })

          await this.cardPayment((payload) => {
            console.log(
              'selected_charge_type=creditcard cardPayment payload ',
              payload
            )
            const { redirectInformation, orderReference } = payload

            // リロード問題を回避するための暫定対処コード
            if (!orderReference?.accessId) {
              //   alert(payload)
              alert(
                payload +
                  '\n3Dセキュア決済が失敗しました。カード情報をご確認下さい。'
              )
              return
            }

            localStorage.setItem('accessId', orderReference.accessId)
            localStorage.setItem(
              'formTokenId',
              (this.sales_data || {}).o_application_id
            )
            localStorage.setItem('formSalesId', (this.sales_data || {}).id)
            localStorage.setItem('sourceView', 'opayment')
            // 成功時のみ完了フラグをセット
            localStorage.setItem('paymentComplete', '1')
            location.href = redirectInformation.redirectUrl
            console.log('決済完了', location.href)
          }).catch(async (error) => {
            let error_json = error?.message
            console.log('error', error_json)
            if (this.is_json(error_json)) {
              const errorCode = []
              const parsedError = JSON.parse(error_json)
              if (parsedError) {
                for (const key in parsedError) {
                  if (
                    parsedError[key].legacyCode &&
                    !errorCode.includes(parsedError[key].legacyCode)
                  ) {
                    errorCode.push(parsedError[key].legacyCode)
                  }
                }
              }
              const error_msg =
                'カード決済エラーです。' +
                ((Array.isArray(errorCode) && errorCode.length > 0)
                  ? 'エラーコード:' + errorCode.join(',')
                  : '')
              alert(error_msg + 'カード情報を確認して下さい。')
              // console.log(errorCode)
            } else {
              alert('カード決済エラーです。カード情報を確認して下さい。')
            }
            // console.log(error)
            if (this.get_base_env == 'production') {
              // await this.update_app_check(400)
            } else {
              // await this.charge_challenge_countup((this.sales_obj || {}).id)
            }
            // await this.loadApplicationObj()
          })
        } catch (error) {
          console.error('決済処理全体エラー:', error)
          alert(
            `決済処理中にエラーが発生しました: ${
              error.message || 'システムエラー'
            }`
          )
        } finally {
          this.isLoading = false
          this.charge_btn_disabled = false
        }
      },
      async update_app_check(check_type) {
        console.log('update_app_check check_type', check_type)
        const post_url_path =
          this.sales_data.o_application_id > 0
            ? '/owner_application/edit/' + this.sales_data.o_application_id
            : '/owner_application/add'

        const params = {
          o_id: (this.data_obj || {}).id ? (this.data_obj || {}).id : 0,
          application_check_type: check_type,
        }
        await this.basicPosts_I(config.BASE_API_URL + post_url_path, params)
          .then(async (response) => {
            console.log('update_app_check', response)
          })
          .catch(async (err) => {
            console.log(err)
          })
          .finally(async () => {
            // await this.go_app();
            if (check_type != 403 && check_type != 500)
              await this.loadApplicationObj()
            this.charge_btn_disabled = false
            this.$forceUpdate()
          })
      },

      async chargeCash({ name, nameKana, phoneNumber, code }) {
        this.charge_btn_disabled = true
        const payer_tmp = { ...this.get_payer }
        payer_tmp.name = name
        payer_tmp.nameKana = nameKana
        payer_tmp.phones = [
          {
            type: 'MOBILE',
            countryCode: '81',
            number: phoneNumber,
          },
        ]
        const payload = {
          payer: payer_tmp,
          merchant: this.get_merchant,
          order: this.get_order,
          cashOptions: {
            konbiniCode: code,
            paymentPeriod: '10',
          },
        }
        console.log('testtest payload', payload)
        await this.setPaymentPayload(payload).catch(alert)

        const formToken = (this.application_obj || {}).member_regist_token || ''
        const formTokenId = (this.sales_data || {}).o_application_id
        const formSalesId = (this.sales_data || {}).id
        console.log(
          'formToken formTokenId formSalesId',
          formToken,
          formTokenId,
          formSalesId
        )

        try {
          await this.cashPaymentForOwner(
            formToken,
            formTokenId,
            formSalesId,
            async (payload) => {
              console.log('testtest payload cashPayment', payload)
              if (!payload) {
                throw new Error('決済処理の結果が取得できませんでした。')
              }
              const { cashResult } = payload
              if (!cashResult) {
                throw new Error('決済情報が取得できませんでした。')
              }
              this.receipt = cashResult.konbiniPaymentInformation
              this.has_receipt_data = true
              console.log('testtest receipt', this.receipt)
              const chk = await this.updateSalesReceipt(formSalesId)
              if (chk) {
                await this.update_app_check(420)
              }
            }
          )
        } catch (error) {
          console.error('コンビニ決済エラー:', error)
          alert(error.message || 'コンビニ決済の処理中にエラーが発生しました。')
          await this.update_app_check(400)
        }
      },
      async updateSalesReceipt(formSalesId) {
        // sales update
        const sales_url_path =
          formSalesId > 0 ? '/sales/konbini_set/' + formSalesId : false
        const sales_params = {
          sales_type: 'owner_event',
          charge_type: 'KONBINI',
          cash_konbini_code: this.receipt?.konbiniCode,
          cash_receipt_number: this.receipt?.receiptNumber,
          cash_confirmation_number: this.receipt?.confirmationNumber,
        }
        const chk = sales_url_path
          ? await this.basicPosts_I(
              config.BASE_API_URL + sales_url_path,
              sales_params
            )
          : false
        return chk
      },
      async loadApplicationObj() {
        const params = {}
        params['stat'] = [1]
        params['o_id'] = this.data_obj.id
        params['application_type'] = 11500
        params['not_application_check_types'] = [500, 900]
        if(this.sales_data.o_application_id){
          params['o_application_id'] = this.sales_data.o_application_id
        }
        await this.basicPosts_S(
          config.BASE_API_URL + '/owner_application/lists',
          params
        )
          .then(async (response) => {
            console.log('loadApplicationObj', response, this.sales_data.o_application_id)
            // sales.id=77のデータをフィルタリング
            if(
              this.sales_data.o_application_id
            ){

              const filteredData =
                response.data?.body?.find(
                  (item) =>
                    item.id &&
                    item.id === this.sales_data.o_application_id
                ) || {}

              this.application_obj = filteredData
            }else{
              const filteredData =
              response.data?.body?.find(
                (item) =>
                  item.sales &&
                  item.sales.id === this.router.currentRoute.value.query.tkn
              ) || {}

            this.application_obj = filteredData
            }
          })
          .catch(async (err) => {
            console.log(err)
            this.application_obj = {}
          })
          .finally(async () => {
            await this.setApplicationObj()
            // await this.setDraftOrderObj();
            // await this.setSalesObj()
            
            await this.loadSalesData()
            this.$forceUpdate()
          })
      },

      async loadOwnerObj() {
        const params = {}
        params['stat'] = [1]
        if(this.get_auth?.userId){
          params['id'] = this.get_auth.userId
        }else if(this.get_auth.token){
          params['token'] = this.get_auth.token
        }
        params['pagegroup'] = 'mfj_owner_data.id';
        console.log('loadOwnerObj params', params)
        await this.basicPosts_S(config.BASE_API_URL + '/owner/lists', params)
          .then(async (response) => {
            console.log('loadOwnerObj', response)
            this.data_obj =
              response.data && response.data.body && response.data.body[0]
                ? response.data.body[0]
                : {}
            if(
              response.data && response.data.body && response.data.body[0]
            ){
              let payer_name =  (this.data_obj || {}).name_2
              payer_name += ( (this.data_obj || {}).name_3)?  (this.data_obj || {}).name_3: ''
              let payer_yomi =  (this.data_obj || {}).yomi_2
              payer_yomi += ( (this.data_obj || {}).yomi_3)?  (this.data_obj || {}).yomi_3: ''
              const obj_tmp = {}
              obj_tmp.name = (payer_name && payer_name != 'null' && payer_name != null)? payer_name: ''
              obj_tmp.nameKana = (payer_yomi && payer_yomi != 'null' && payer_yomi != null)? payer_yomi: ''
              obj_tmp.phoneNumber = (this.data_obj || {}).tel_1
              this.card_payer_obj = {...obj_tmp}
              const obj_btmp = {}
              obj_btmp.name = payer_yomi
              obj_btmp.city = ((this.data_obj || {}).address_1)?  (this.data_obj || {}).address_1: ''
              obj_btmp.country = '392'
              obj_btmp.line1 = ((this.data_obj || {}).address_1)?  (this.data_obj || {}).address_1: ''
              obj_btmp.postCode = ((this.data_obj || {}).postal_cd)?  (this.data_obj || {}).postal_cd: ''
              obj_btmp.state = ((this.data_obj || {}).pref_cd)?  (this.data_obj || {}).pref_cd.toString().padStart(3, '0'): ''
              this.card_payer_billingAddress = {...obj_btmp}
            }
          })
          .catch(async (err) => {
            console.log('loadOwnerObj err', err)
            this.data_obj = {}
          })
          .finally(async () => {
            if (!this.data_obj.id) {
              alert(
                '主催者が指定されていません。'
              )
              location.href = config.BASE_APP_URL
            } 
            await this.setOwnerObj()
            this.$forceUpdate()
          })
      },

      async setOwnerObj() {
        // have_licenseにいれるのはattach_have_licenseに集約
        // const tmps = (typeof (this.data_obj || {}).member_license === 'object')? [...(this.data_obj || {}).member_license]: []
        // this.have_license = tmps.filter(license => license.license_year == this.get_term_year)
        this.form_obj = {
          name_1: (this.data_obj || {}).name_1,
          name_2: (this.data_obj || {}).name_2,
          yomi_1: (this.data_obj || {}).yomi_1,
          yomi_2: (this.data_obj || {}).yomi_2,
          birth_date: (this.data_obj || {}).birth_date,
          postal_cd: (this.data_obj || {}).postal_cd,
          pref_cd: (this.data_obj || {}).pref_cd,
          address_1: (this.data_obj || {}).address_1,
          address_2: (this.data_obj || {}).address_2,
          tel_1: (this.data_obj || {}).tel_1,
          tel_2: (this.data_obj || {}).tel_2,
          // member_assets: (this.data_obj || {}).member_assets,
        }
        await this.attach_have_license()
      },
      async attach_have_license() {
        // 配列が存在するかチェック
        if (!this.member_license || !Array.isArray(this.member_license)) {
          this.member_license = [] // 配列が未定義なら初期化
        }

        if (this.selected_year?.length > 0) {
          const license_list =
            typeof (this.data_obj || {}).member_license === 'object'
              ? [...(this.data_obj || {}).member_license]
              : []
          const tmps = []
          this.selected_year.map((year_add) => {
            tmps.push(parseInt(this.get_term_year) + parseInt(year_add))
          })
          const lc_tmp = license_list
            .filter((license) => tmps.includes(parseInt(license.license_year)))
            .map((license) => {
              if (
                parseInt(license.license_year) > parseInt(this.get_term_year)
              ) {
                license.year_add = 1
              } else {
                license.year_add = 0
              }
              return license
            })
          this.have_license = [...lc_tmp]
        }
      },

      async loadMerchantObj(target_merchant) {
        await this.basicPosts_S(
          config.BASE_API_URL + '/merchant/' + target_merchant,
          {}
        )
          .then(async (response) => {
            console.log('loadMerchantObj', response)
            this.merchant_obj =
              response.data && response.data.body ? response.data.body : {}
            console.log('loadMerchantObj merchant_obj', this.merchant_obj)
          })
          .catch(async (err) => {
            console.log(err)
            this.merchant_obj = {}
          })
          .finally(async () => {
            this.$forceUpdate()
          })
      },
      async update_sales_order_id(to_type){
        const sales_id = (
        (this.sales_data || {}).id
        )? (this.sales_data || {}).id: false
        if(!sales_id) {
            alert('データがありません')
            this.selected_charge_type = 'creditcard'
            return 
        }
        
        const order_id = (
        (this.sales_data || {}).charge_order_id
        )? (this.sales_data || {}).charge_order_id: false
        if(!order_id) {
            alert('決済IDがありません')
            this.selected_charge_type = 'creditcard'
        return 
        }
        let up_order_id = order_id
        const chk_p_1 = order_id.slice(20)
        const chk_p_2 = (chk_p_1)? chk_p_1.indexOf('C'): false
        // クレジット->コンビニ
        if(
            to_type == 'cash'
            && this.selected_charge_type == 'creditcard'
        ){
            if(
                chk_p_2 !== false && chk_p_2 !== -1
                // order_id.includes('-')
            ){
                let splitPos = chk_p_2 + 20;
                up_order_id = order_id.slice(0, splitPos) + 'K'
                // const tmps = order_id.split('-')
                // up_order_id = tmps[0] + 'K'
            }
            else if(
                !order_id.endsWith('K')
            ){
                up_order_id = order_id + 'K'
            }
        }
        // コンビニ->クレジット
        else if(
            to_type == 'creditcard'
            && this.selected_charge_type == 'cash'
        ){
            if(
                chk_p_2 !== false && chk_p_2 !== -1
                // order_id.includes('-')
            ){
                let splitPos = chk_p_2 + 20;
                up_order_id = order_id.slice(0, splitPos)
                // const tmps = order_id.split('-')
                // up_order_id = tmps[0]
            }
            else if(
                order_id.endsWith('K')
            ){
                up_order_id = order_id.slice(0, -1)
            }

            // count
            if(
                (this.sales_data || {}).charge_challenge > 0
            ){
                up_order_id += 'C' + (this.sales_data || {}).charge_challenge
            }
        }
        else{
            this.selected_charge_type = to_type
            return
        }

        this.selected_charge_type = to_type
        // sales update
        const sales_url_path =
        sales_id > 0
            ? '/sales/edit/' + sales_id
            : false
        const sales_params = {
            charge_type: (to_type=='cash')? 'KONBINI': 'CREDIT',
            charge_order_id: up_order_id,
        }
        console.log('sales_params', sales_params)
        const chk = (sales_url_path)? await this.nonloginPosts_I(
            config.BASE_API_URL + sales_url_path,
            sales_params
        ): false
        console.log('sales_params chk', chk)
        if(chk){
            return up_order_id
        }
        return chk
      },
    },
    computed: {
      get_auth: function(){
        return this.$store.state.oauth
      },
      get_target_app_item: function () {
        const application = this.application_obj
        return function (app_key) {
          if (
            typeof application === 'object' &&
            typeof application.items === 'object'
          ) {
            return application.items.find(
              (app) => app.application_key == app_key
            )
          }
          return {
            application_value: '',
          }
        }
      },
      set_payer_obj: function(){
        const payer_obj = {}
        // payer_obj.name = this.card_payer_obj?.name
        payer_obj.name = this.card_payer_obj?.nameKana
        payer_obj.nameKana = this.card_payer_obj?.nameKana
        payer_obj.phoneNumber = this.card_payer_obj?.phoneNumber
        const phone_tmp = {}
        phone_tmp.number = payer_obj.phoneNumber
        phone_tmp.countryCode = '81'
        if (
          typeof payer_obj.phoneNumber === 'string' &&
          ((this.data_obj || {}).tel_1.startsWith('090') ||
            (this.data_obj || {}).tel_1.startsWith('080') ||
            (this.data_obj || {}).tel_1.startsWith('070'))
        ) {
          phone_tmp.type = 'MOBILE'
        } else {
          phone_tmp.type = 'MOBILE'
        }
        payer_obj.phones = []
        payer_obj.phones.push(phone_tmp)
        return payer_obj

      },
      get_payer: function () {
        const payer_obj = {}
        // payer_obj.name = (this.data_obj || {}).name_1 + (this.data_obj || {}).name_2
        let payer_name =  (this.data_obj || {}).yomi_2
        payer_name += ( (this.data_obj || {}).yomi_3)?  (this.data_obj || {}).yomi_3: ''
        payer_obj.name = (payer_name && payer_name != 'null' && payer_name != null)? payer_name: ''
        payer_obj.nameKana = (payer_name && payer_name != 'null' && payer_name != null)? payer_name: ''
        payer_obj.phoneNumber = (this.data_obj || {}).tel_1
        const phone_tmp = {}
        phone_tmp.number = (this.data_obj || {}).tel_1
        phone_tmp.countryCode = '81'
        if (
          typeof (this.data_obj || {}).tel_1 === 'string' &&
          ((this.data_obj || {}).tel_1.startsWith('090') ||
            (this.data_obj || {}).tel_1.startsWith('080') ||
            (this.data_obj || {}).tel_1.startsWith('070'))
        ) {
          phone_tmp.type = 'MOBILE'
        } else {
          phone_tmp.type = 'MOBILE'
        }
        payer_obj.phones = []
        payer_obj.phones.push(phone_tmp)
        return payer_obj
      },
      get_merchant: function () {
        const merchant_obj = { ...this.merchant_obj }
        merchant_obj.callbackUrl = config.GMO_CALLBACK_URL + '/owner/3ds'
        merchant_obj.webhookUrl = config.GMO_WEBHOOK_URL

        return merchant_obj
      },
      
      get_order: function () {
        const order = {
          orderId: (this.sales_data || {}).charge_order_id,
          amount: (this.sales_data || {}).amount,
          currency: 'JPY',
          // clientFields: [],
          items: [],
        }
        if(this.get_order_billingAddress){
            order.billingAddress = this.get_order_billingAddress
        }
        if (
          typeof (this.sales_data || {}).sales_orders === 'object' &&
          (this.sales_data || {}).sales_orders.length > 0
        ) {
          order.items = []
          this.sales_data.sales_orders.map((sales_order) => {
            order.items.push({
              name: sales_order.sub_label,
              quantity: sales_order.num,
              type: 'DIGITAL',
              price: sales_order.list_price,
            })
          })
        }
        return order
      },
      get_order_billingAddress: function(){
        let chk = true
        Object.values(this.card_payer_billingAddress).forEach(ba => {
          if(chk != false && !ba){
            chk = false
          }
        })
        return (chk)? this.card_payer_billingAddress: false
      }
    },

    async created() {
      // 決済完了フラグをlocalStorageから確認
      if (localStorage.getItem('paymentComplete') === '1') {
        this.isPaymentComplete = true
        localStorage.removeItem('paymentComplete') // 一度だけ表示
      } else {
        this.isPaymentComplete = false
      }
      try {
        await this.loadMerchantObj('mfj')
        await this.setApplicationObj()
        await this.loadOwnerObj()
        await this.setOwnerObj()
        if (!this.isPaymentComplete) {
          await this.loadSalesData()
          .finally(async () => {
            console.log('check loadSalesData', this.get_auth)
          })
          await this.loadApplicationObj()
          // await this.mp_token_mount()
        }
      } catch (error) {
        console.error('初期化エラー:', error)
      }
    },

    async mounted() {
      console.log('mounted !')
    },
    // async update_app() {
    //   const member = { ...this.data_obj }
    //   console.log('component methods', this.data_obj)

    //   const post_url_path =
    //     this.sales_data.o_application_id > 0
    //       ? '/owner_application/edit/' + this.sales_data.o_application_id
    //       : '/owner_application/add'

    //   const check_type =
    //     // 更新がある
    //     // 更新時顔写真を変えている
    //     (typeof this.app_form_obj === 'object' && this.app_form_obj.path3) ||
    //     // 継続(追加も原則上必要かもしれない)未成年者であれば年度継続者はMFJ承認が必要
    //     this.chk_parent_accept ||
    //     // 追加がある
    //     // 追加時、3時間証明が必要
    //     this.chk_license_join_3hour ||
    //     // 追加時、対面講習会を選択している。
    //     this.chk_order_license_join_seminar_circuit ||
    //     // 決済が0円
    //     this.selected_variants
    //       ?.map((item) => parseInt(item.price))
    //       .reduce((acc, curr) => acc + curr, 0) === 0
    //       ? 100
    //       : this.data_obj?.trans_period == 1
    //       ? 100
    //       : this.data_obj?.continue_app_type == 1
    //       ? 100
    //       : 400
    //   console.log('update_app check_type', check_type)

    //   const params = {
    //     application_check_type: check_type,
    //     application_type: 11300,
    //     o_id: this.$store.state.oauth.userId,
    //     // application_type: this.upd_obj.application_check_type,
    //     // application_check_type: this.upd_obj.application_check_type,
    //     // items: [],
    //   }

    //   const item_column = {
    //     path3: 'mfj_member_assets@path3',
    //   }
    //   if (this.chk_license_join_3hour) {
    //     item_column['path10'] = 'mfj_member_assets@path10'
    //     item_column['path11'] = 'mfj_member_assets@path11'
    //   }

    //   const items = []
    //   Object.keys(item_column).forEach((item_key) => {
    //     items.push({
    //       id: this.get_target_app_item(item_column[item_key])
    //         ? (this.get_target_app_item(item_column[item_key]) || {}).id
    //         : 0,
    //       application_id: this.application_obj.id,
    //       application_key: item_column[item_key],
    //       application_value: this.app_form_obj[item_key],
    //     })
    //   })
    //   params.items =
    //     typeof items === 'object' && items.length > 0 ? items : false

    //   // draft_order
    //   const draft_orders = []
    //   if (
    //     typeof this.selected_variants === 'object' &&
    //     this.selected_variants.length > 0
    //   ) {
    //     this.selected_variants.forEach((variant) => {
    //       draft_orders.push({
    //         id: variant.draft_order_id,
    //         stat: 1,
    //         application_id: 0,
    //         variant_id: variant.variant_id,
    //         sports_year: variant.sports_year,
    //         unit_price: variant.price,
    //         num: 1,
    //         list_price: parseInt(variant.price) * 1,
    //         join_3hour_circuit_id: variant.join_3hour_circuit_id,
    //         join_3hour_circuit_license_no:
    //           variant.join_3hour_circuit_license_no,
    //         join_3hour_circuit_license_file:
    //           variant.join_3hour_circuit_license_file,
    //         join_discount_check_file: variant.join_discount_check_file,
    //         join_seminar_type: variant.join_seminar_type,
    //         join_seminar_place: variant.join_seminar_place,
    //         join_seminar_date: variant.join_seminar_date,
    //       })
    //     })
    //   }
    //   console.log('draft_orders', draft_orders)
    //   params.draft_orders = draft_orders

    //   let app_id = this.application_obj.id > 0 ? this.application_obj.id : 0

    //   await this.basicPosts_I(config.BASE_API_URL + post_url_path, params)
    //     .then(async (response) => {
    //       console.log('update', response)
    //       app_id =
    //         response.data &&
    //         response.data.body &&
    //         response.data.body[0] &&
    //         response.data.body[0].id
    //           ? response.data.body[0].id
    //           : 0
    //     })
    //     .catch(async (err) => {
    //       console.log(err)
    //       this.page_mode = 'error'
    //     })
    //     .finally(async () => {
    //       // await this.loadApplicationObj();
    //       this.change_mode_value = false
    //       this.message = '申請しました。'
    //       // 更新がある
    //       // 更新時顔写真を変えている
    //       if (check_type == 100) {
    //         this.page_mode = 'check'
    //         await this.loadApplicationObj()
    //       }
    //       //それ以外はチェック
    //       else {
    //         this.page_mode = 'charge'
    //         app_id = app_id ? app_id : this.application_obj.id
    //         // console.log('update_app charge app_id', app_id);
    //         await this.app_order(member.id, app_id, draft_orders)
    //         await this.loadApplicationObj()
    //       }
    //       this.$forceUpdate()
    //     })
    // },
    async cancel() {
      if (window.confirm('変更を取りやめます。よろしいですか？')) {
        const post_url_path =
          this.application_obj.id > 0
            ? '/owner_application/edit/' + this.application_obj.id
            : '/owner_application/add'
        const params = {
          o_id: this.$store.state.oauth.userId,
          stat: 9,
        }
        await this.basicPosts_I(config.BASE_API_URL + post_url_path, params)
          .then(async (response) => {
            console.log('update', response)
          })
          .catch(async (err) => {
            console.log(err)
          })
          .finally(async () => {
            await this.loadApplicationObj()
            this.change_mode_value = false
            this.message = '変更申請をキャンセルしました'
            this.$forceUpdate()
          })
      }
    },

    beforeUnmount() {
      try {
        if (this.cardNumberElement) {
          this.cardNumberElement.unmount()
        }
        if (this.expiryElement) {
          this.expiryElement.unmount()
        }
        if (this.cvcElement) {
          this.cvcElement.unmount()
        }
        this.clear()
      } catch (error) {
        console.error('アンマウント時のエラー:', error)
      }
    },
  }
</script>

<style scoped>
  .card-form__div {
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    padding: 0.375rem 0.75rem;
    margin-bottom: 1rem;
  }

  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
</style>
